import { useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { Tabs } from "../../../../components/common/Tabs";
import { AllEmailsSent } from "./AllEmailsSent";
import { Queued } from "./Queued";
import { Failed } from "./Failed";
import { Deferred } from "./Deferred";
import { Delivered } from "./Delivered";

const tabs = [
  {
    label: "All",
  },
  {
    label: "Queued",
  },
  {
    label: "Failed",
  },
  {
    label: "Deferred",
  },
  {
    label: "Delivered",
  },
]

export const EmailsSent = () => {
  const { themeStyles } = useTheme();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        
        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {
            activeIndex === 0 && (
              <AllEmailsSent />
            )
          }
          {
            activeIndex === 1 && (
              <Queued />
            )
          }
          {
            activeIndex === 2 && (
              <Failed />
            )
          }
          {
            activeIndex === 3 && (
              <Deferred />
            )
          }
          {
            activeIndex === 4 && (
              <Delivered />
            )
          }
        </div>
      </div>
    </div>
  )
}

